import type { components } from '@/generated/contracts/api-v1';
import type { RendererBridge } from './RendererBridge';

type Schemas = components['schemas'];

/** A saved placement as createAssetInstance answers it: the asset instance and what was created with it. */
export interface Placement {
  assetInstance: Schemas['AssetInstanceDto'];
  keyframes: Schemas['KeyframeDto'][];
  clipInstances: Schemas['ClipInstanceDto'][];
}

/**
 * Tells the renderer about a saved placement: the asset instance first, so it registers it, then its keyframes
 * and its clips (an audio or video asset's playback clip among them), each as saved. `restored` when undo or
 * redo re-created it, so the renderer takes it exactly as sent rather than placing a new one.
 */
export function sendPlacement(bridge: Pick<RendererBridge, 'send'>, placed: Placement, restored: boolean): void {
  bridge.send({ type: 'assetInstanceAdded', assetInstance: placed.assetInstance, restored });
  for (const keyframe of placed.keyframes) bridge.send({ type: 'keyframeAdded', keyframe, restored });
  for (const clipInstance of placed.clipInstances) bridge.send({ type: 'clipInstanceAdded', clipInstance, restored });
}
